import { api } from "@/api/api";

export const PC = {
    state: {
        pcList: [],
        totalCount: 0,
    },
    getters: {
        getPCList(state) {
            return state.pcList;
        },
        getPCTotalCount(state) {
            return state.totalCount;
        }
    },
    mutations: {
        setPCList(state, payload) {
            state.pcList = payload;
        },
        setPCTotalCount(state, payload) {
            state.totalCount = payload;
        }
    },
    actions: {
        async getPCList({ commit }, param) {
            await api.pc
                .getPCList(param)
                .then((res) => {
                    console.log(res);
                    commit("setPCList", res.data.pc);
                    commit("setPCTotalCount", res.data.total)
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async getPC(_, id) {
            const response = await api.pc.getPC(id).catch((err) => {
                console.log(err);
                return Promise.reject(err.response.data.message);
            });
            return Promise.resolve(response.data);
        },

        async addPC({ dispatch }, args) {
            await api.pc
                .addPC(args)
                .then(() => {
                    dispatch("getPCList");
                })
                .catch((err) => {
                    console.log(err);
                    return Promise.reject(err.response.data.message);
                });
            return Promise.resolve();
        },

        async updatePC({ dispatch }, args) {
            await api.pc
                .updatePC(args)
                .then(() => {
                    dispatch("getPCList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async deletePC({ dispatch }, args) {
            await api.pc
                .deletePC(args)
                .then(() => {
                    dispatch("getPCList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async updateAnswer(_, args) {
            await api.pc.updateAnswer(args.id, args.param).catch((err) => {
                console.timeLog(err)
            })
            return Promise.resolve();

        }
    },
};
